export default {
      id: "logo-usage",
      viewBox: "0 0 2564 440",
      url: "../../assets/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }